// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2ebTJ","amount":"Amount_amount__zMxAZ","tip":"Amount_tip__DQ-GE","tipHeader":"Amount_tipHeader__2wJqK","tipsWrap":"Amount_tipsWrap__24Vhv"};